const initialState = {
  permissionFlags: null,
  responseData: null,
  databaseTables: [],
  collections: [],
  collectionsByAppwrite: [],
  inMemoryCollections: [],
  externalDbUuid: '',
  databaseByAppwrite: '',
  collectionsByAppwrite: '',
  externalDatabase: '',
  collectionDetailsByAppwrite: '',
  externalApisExternalDataSources: [],
  eventsExternalDataSources: [],
  collectionsExternalDataSources: [],
  workSpaceByXata: null,
  databasesByXata: null,
  externalDbUuidXata: '',
  externalDatabaseXata: null,
  schemaForXata: null,
  collectionByDirectus: null,
  externalDbDirectus: null,
  schemaForDirectus: null,
  airtableWorkspaces: null,
  airtableTables: null,
  externalDbAirtable: null,
  enableCollectionMapping: false,
  dataConnector: null,
  loadCollectionsPending: false,
  loadCollectionsError: null,
  deleteConnectorSettingPending: false,
  deleteConnectorSettingError: null,
  loadDataConnectorPending: false,
  loadDataConnectorError: null,
  deleteSourceConnectorPending: false,
  deleteSourceConnectorError: null,
  refreshSourceDataPending: false,
  refreshSourceDataError: null,
  getDataEditPending: false,
  getDataEditError: null,
  getDataEditOne: {},
  getExternalDataBasePending: false,
  getExternalDataBaseError: null,
  externalDataBaseData: [],
  xanoTableData: [],
  xanoDataSourceTables: [],
  loadAppwriteExternaldbPending: false,
  loadAppwriteExternaldbError: null,
  collectionList: [],
  schemaData: [],
  xanoDataBaseTable: [],
  xanoSavedData: {},
  xanoStoredData: {},
  xanoExternalDb: {},
  getXanoSchemaData: [],
  supabaseData: {},
  supabaseExternalData: {},
  supabaseStoredData: {},
  xanoInstance: {},
  xanoTokenUrlData: {},
  xanoApiGroupsData: {},
  salesforceCollections: null,
  externalDbSalesforce: null,
  schemaForSalesforce: null,
  collectionListExternaldbsPending: false,
  collectionListExternaldbsError: null,
  getxanoSchemaPending: false,
  getxanoSchemaError: null,
  xanoUpdateCollectionPending: false,
  xanoUpdateCollectionError: null,
  xanoDataBaseTablePending: false,
  xanoDataBaseTableError: null,
  getXanoTablePending: false,
  getXanoTableError: null,
  saveDataInExternalDbPending: false,
  saveDataInExternalDbError: null,
  getStoredXanoDataPending: false,
  getStoredXanoDataError: null,
  xanoSchemaPending: false,
  xanoSchemaError: null,
  createCollectionfromXanoPending: false,
  createCollectionfromXanoError: null,
  saveXanoFieldsPending: false,
  saveXanoFieldsError: null,
  loadAppwriteExternaldbPending: false,
  loadAppwriteExternaldbError: null,
  loadCollectionsByAppwritePending: false,
  loadCollectionsByAppwriteError: null,
  loadAppwriteCollectionDetailsPending: false,
  loadAppwriteCollectionDetailsError: null,
  appwriteCollectionUpdatePending: false,
  appwriteCollectionUpdateError: null,
  getDatabasesForAppwritePending: false,
  getDatabasesForAppwriteError: null,
  getCollectionsByAppwritePending: false,
  getCollectionsByAppwriteError: null,
  saveDataInExternaldatabasePending: false,
  saveDataInExternaldatabaseError: null,
  loadExternalDatabasePending: false,
  loadExternalDatabaseError: null,
  createCollectionWithAppwritePending: false,
  createCollectionWithAppwriteError: null,
  appwriteUpdateExternalDatabasePending: false,
  appwriteUpdateExternalDatabaseError: null,
  getSupabaseDataPending: false,
  getSupabaseDataError: null,
  saveSupabaseDataInExternalDbPending: false,
  saveSupabaseDataInExternalDbError: null,
  createCollectionfromSupabasePending: false,
  createCollectionfromSupabaseError: null,
  getSupabaseExternalDbPending: false,
  getSupabaseExternalDbError: null,
  updateSupabaseExternalDbPending: false,
  updateSupabaseExternalDbError: null,
  supabaseUpdateCollectionPending: false,
  supabaseUpdateCollectionError: null,
  xataWorkspaceListPending: false,
  xataWorkspaceListError: null,
  getDatabasesForXataPending: false,
  getDatabasesForXataError: null,
  xataSaveExternalDatabasePending: false,
  xataSaveExternalDatabaseError: null,
  loadExternalDatabaseForXataPending: false,
  loadExternalDatabaseForXataError: null,
  getSchemaForXataCollectionPending: false,
  getSchemaForXataCollectionError: null,
  updateTableAndFieldsForXataPending: false,
  updateTableAndFieldsForXataError: null,
  createCollectionWithXataPending: false,
  createCollectionWithXataError: null,
  updateCollectionWithXataPending: false,
  updateCollectionWithXataError: null,
  getCollectionsForDirectusPending: false,
  getCollectionsForDirectusError: null,
  saveExternaldatabaseForDirectusPending: false,
  saveExternaldatabaseForDirectusError: null,
  loadExternalDatabaseForDirectusPending: false,
  loadExternalDatabaseForDirectusError: null,
  getSchemaForDirectusCollectionPending: false,
  getSchemaForDirectusCollectionError: null,
  createCollectionWithDirectusPending: false,
  createCollectionWithDirectusError: null,
  updateExternalDatabaseForDirectusPending: false,
  updateExternalDatabaseForDirectusError: null,
  updateCollectionForDirectusPending: false,
  updateCollectionForDirectusError: null,
  deleteExternalDatabasePending: false,
  deleteExternalDatabaseError: null,
  airtableWorkspaceListPending: false,
  airtableWorkspaceListError: null,
  airtableGetTablesPending: false,
  airtableGetTablesError: null,
  saveExternaldatabaseForAirtablePending: false,
  saveExternaldatabaseForAirtableError: null,
  loadExternalDatabaseForAirtablePending: false,
  loadExternalDatabaseForAirtableError: null,
  createCollectionWithAirtablePending: false,
  createCollectionWithAirtableError: null,
  airtableUpdateExternalDatabasePending: false,
  airtableUpdateExternalDatabaseError: null,
  updateCollectionForAirtablePending: false,
  updateCollectionForAirtableError: null,
  getXanoInstancePending: false,
  getXanoInstanceError: null,
  xanoTokenUrlPending: false,
  xanoTokenUrlError: null,
  getXanoApiGroupsPending: false,
  getXanoApiGroupsError: null,
  getCollectionsForSalesforcePending: false,
  getCollectionsForSalesforceError: null,
  loadExternalDatabaseForSalesforcePending: false,
  loadExternalDatabaseForSalesforceError: null,
  getSchemaForSalesforceCollectionPending: false,
  getSchemaForSalesforceCollectionError: null,
  createCollectionWithSalesforcePending: false,
  createCollectionWithSalesforceError: null,
  saveExternaldatabaseForSalesforcePending: false,
  saveExternaldatabaseForSalesforceError: null,
  updateExternaldatabaseForSalesforcePending: false,
  updateExternaldatabaseForSalesforceError: null,
  updateCollectionForSalesforcePending: false,
  updateCollectionForSalesforceError: null,
  loadProjectExternalDbCollectionsPending: false,
  loadProjectExternalDbCollectionsError: null,
  loadEventsExternalDataSourcePending: false,
  loadEventsExternalDataSourceError: null,
  loadExternalApisExternalDbPending: false,
  loadExternalApisExternalDbError: null,
  updateTablesAndFieldsPending: false,
  updateTablesAndFieldsError: null,
  supabaseEnvironmentVariablesPending: false,
  supabaseEnvironmentVariablesError: null,
  updateTablesAndFieldsAppwritePending: false,
  updateTablesAndFieldsAppwriteError: null,
  appwriteEnvironmentPending: false,
  appwriteEnvironmentError: null,
  updateDirectusTablesPending: false,
  updateDirectusTablesError: null,
  getXanoExternalDbPending: false,
  getXanoExternalDbError: null,
  createEnvironmentVariablesPending: false,
  createEnvironmentVariablesError: null,
  getPermissionFlagsPending: false,
  getPermissionFlagsError: null,
  getMySqlDataSourceDataPending: false,
  getMySqlDataSourceDataError: null,
  saveMySqlDataInExternalDbPending: false,
  saveMySqlDataInExternalDbError: null,
  getMySqlExternalDbPending: false,
  getMySqlExternalDbError: null,
  updateMySqlExternalDbPending: false,
  updateMySqlExternalDbError: null,
  createCollectionWithMySqlPending: false,
  createCollectionWithMySqlError: null,
  updateCollectionWithMySqlPending: false,
  updateCollectionWithMySqlError: null,
  isOpenExternalDbSettingModal: false,
  updateMySqlExternalDbSettingPending: false,
  updateMySqlExternalDbSettingError: null,
  mapCollectionWithMySqlPending: false,
  mapCollectionWithMySqlError: null,
  getMySqlTableSchemaPending: false,
  getMySqlTableSchemaError: null,
  syncMySqlDataSourceTablesPending: false,
  syncMySqlDataSourceTablesError: null,
};

export default initialState;
